import { ComponentType } from 'react';
import {
  SlashCircleFill,
  Clipboard2XFill,
  Calendar2WeekFill,
  EnvelopePaperFill,
  PersonVcardFill,
  FileEarmarkTextFill,
  ConeStriped,
} from 'react-bootstrap-icons';

export interface ServiceItem {
  id: string;
  title: string;
  Icon: ComponentType;
  message: string;
}

export const SERVICES: ServiceItem[] = [
  {
    id: 'admission-dismissal',
    title: 'Admissão e desligamento',
    Icon: SlashCircleFill,
    message: 'Bom dia! Quero falar sobre Admissão e desligamento.',
  },
  {
    id: 'time-control',
    title: 'Controle de ponto e faltas',
    Icon: Clipboard2XFill,
    message: 'Bom dia! Quero falar sobre Controle de ponto e faltas.',
  },
  {
    id: 'vacation-management',
    title: 'Gestão de férias e atestados',
    Icon: Calendar2WeekFill,
    message: 'Bom dia! Quero falar sobre Gestão de férias e atestados.',
  },
  {
    id: 'payroll',
    title: 'Gestão de folha de pagamento',
    Icon: EnvelopePaperFill,
    message: 'Bom dia! Quero falar sobre Gestão de folha de pagamento.',
  },
  {
    id: 'hr-indicators',
    title: 'Indicadores de RH e auditorias',
    Icon: PersonVcardFill,
    message: 'Bom dia! Quero falar sobre Indicadores de RH e auditorias.',
  },
  {
    id: 'digital-organization',
    title: 'Organização digital de documentos',
    Icon: FileEarmarkTextFill,
    message: 'Bom dia! Quero falar sobre Organização digital de documentos.',
  },
  {
    id: 'health-safety',
    title: 'Suporte em saúde e segurança do trabalho',
    Icon: ConeStriped,
    message: 'Bom dia! Quero falar sobre Suporte em saúde e segurança do trabalho.',
  },
];

export const PLUS_FEATURES = [
  'Gerenciamento de DCTFWeb',
  'Controle de ponto e horas extras',
  'Envio de documentação à contabilidade',
  'Acompanhamento de férias e prazos',
  'Armazenamento em nuvem seguro',
] as const;
